import { ReactNode, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const RadioButtons = ({
  label,
  subline,
  current = 0,
  onClick,
  options,
  stateProp,
  maxPerRow = 6,
}: {
  label?: string
  subline?: string
  current?: number
  options: { label: string | ReactNode; value: number }[]
  onClick: (id: string, e: number) => void
  stateProp: string
  maxPerRow?: number
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const optionsCount = options.length
  const maxButtonsPerRow = optionsCount < maxPerRow ? optionsCount : maxPerRow
  const rowCount = Math.ceil(optionsCount / maxButtonsPerRow)
  return (
    <RadioButtonsRoot>
      <LabelRow>
        {label && <Label>{label}</Label>}
        {subline && <SubLine>{subline}</SubLine>}
      </LabelRow>

      <ButtonGroup
        style={{ flexWrap: optionsCount < maxPerRow ? 'nowrap' : 'wrap' }}
      >
        {options.map((option, index) => {
          const currentRow = Math.ceil((index + 1) / maxButtonsPerRow)
          return (
            <RadioButton
              key={option.value}
              selected={current === option.value}
              disabled={current === option.value}
              onClick={() => onClick(stateProp, option.value)}
              style={{
                maxWidth: 100 / maxButtonsPerRow + '%',
                minWidth: 100 / maxButtonsPerRow + '%',
                minHeight: isMobile ? '30px' : '40px',
                borderRight:
                  index !== maxButtonsPerRow - 1
                    ? '2px solid var(--site-background)'
                    : '0px',
                borderTopLeftRadius: index == 0 ? 8 : 0,
                borderBottomLeftRadius: index == 0 ? 8 : 0,
                borderTopRightRadius: index===options.length-1?8:0,
                borderBottomRightRadius: index===options.length-1?8:0,
              }}
            >
              {option.label}
            </RadioButton>
          )
        })}
      </ButtonGroup>
    </RadioButtonsRoot>
  )
}

const RadioButtonsRoot = styled.div.attrs({ className: 'slider inputgroup' })`
  display: inline-block;
  box-sizing: border-box;
  margin-left: auto;
  margin-right:auto;
  width: 100%;
  max-width: calc(100vw - 40px);
  text-align: left;
  padding: 15px;
  margin-bottom: 20px;
  color:#0ff;
  * {
    box-sizing: border-box;
  }
  @media screen and (max-width: 712px) {
    padding: 0;
  }
`
const RadioButton = styled.button<{ selected?: boolean }>`
  padding: 4px;
  height: 100%;
  line-height: 1.4em;
  border: 0;
  padding: 15px;
  background-color: ${({ selected }) =>
    !selected ? 'var(--brandblue-bright-5)' : 'var(--yellow-main)'};
  color: ${({ selected }) =>
    !selected ? 'var(--brandblue-bright-2)' : 'var(--brandblue-main)'};
  &:hover:not(:disabled) {
    cursor: pointer;
    background-color: ${({ selected }) =>
      !selected ? 'var(--gray-4)' : 'var(--blue-dark-1)'};
    color: ${({ selected }) => (!selected ? 'var(--gray-2)' : '#fff')};
  }

  @media screen and (max-width: 712px) {
    font-size: 12px;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  padding: 2px;
`
const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  img {
    height: 22px;
    width: 22px;
    flex: 0 0 22px;
    margin-right: 8px;
  }
`

const SubLine = styled.div`
  font-size: 12px;
  color: var(--gray-3);
  flex: 0 0 100%;
  /* padding-left: 8px; */
  padding-bottom: 12px;
  line-height: 1.4em;
`

const Label = styled.label`
  display: block;
  line-height: 1.4em;
  font-size: 18px;
  letter-spacing: 0.25px;
  /* font-weight: 700; */
  color: var(--text-color);
  /* padding-left: 8px; */
  padding-top: 14px;
  padding-bottom: 4px;
  width: 100%;
  flex: 0 0 100%;
  @media screen and (max-width: 712px) {
    font-size: 15px;
  }
`
